import {NgModule} from '@angular/core';
import {CmsConfig, provideConfig} from '@spartacus/core';
import {SmartEditService} from '@spartacus/smartedit/core';
import {SmartEditConfig, SmartEditRootModule} from '@spartacus/smartedit/root';

import {smartEditDecorators} from './decorators';
import {AimoNavigationService} from "../service/navigation/aimo-navigation.service";

@NgModule({
    declarations: [],
    imports: [SmartEditRootModule],
    providers: [
        ...smartEditDecorators,
        provideConfig({
            featureModules: {
                smartEdit: {
                    module: () => import('@spartacus/smartedit').then((m) => m.SmartEditModule),
                },
            },
        } as CmsConfig),
        provideConfig(<SmartEditConfig>{
            smartEdit: {
                storefrontPreviewRoute: 'cx-preview',
                allowOrigin:
                    'localhost:9002, *.valioaimo.fi:9002, *.valioaimo.fi:4200, *.valioaimo.fi:443, toimitustukku-local.valioaimo.fi:9002, ' +
                    'www.google.com:443, siteintercept.qualtrics.com:443, login-eu-c1.cc.sinch.com:443',
            },
        }),
    ],
})
export class SmartEditFeatureModule {
    constructor(private smartEditService: SmartEditService,
                private navigationService: AimoNavigationService,) {
        if (navigationService.isInSmartEditMode()) {
            this.smartEditService.processCmsPage();
        }
    }
}
